import { Theme } from '@workos-inc/design-system';
import { useRouter } from 'next/router';
import { Popover } from 'radix-ui';
import * as React from 'react';
import { NavigationItems } from './navigation-items';
export const NavigationPopover: React.FC<{
  children?: React.ReactNode;
}> = ({
  children
}) => {
  const router = useRouter();
  const [open, setOpen] = React.useState(false);
  const triggerRef = React.useRef<HTMLButtonElement>(null);

  // Close popover on item selection or route change
  React.useEffect(() => {
    if (open) {
      const handleRouteChange = () => setOpen(false);
      router.events.on('routeChangeStart', handleRouteChange);
      return () => router.events.off('routeChangeStart', handleRouteChange);
    }
  }, [router.events, open]);
  React.useEffect(() => {
    const handleResize = () => {
      setOpen(false);
      triggerRef.current?.focus();
    };
    if (open) {
      addEventListener('resize', handleResize);
      return () => removeEventListener('resize', handleResize);
    }
  }, [open]);
  return <Popover.Root modal open={open} onOpenChange={newOpen => setOpen(newOpen)} data-sentry-element="Popover.Root" data-sentry-component="NavigationPopover" data-sentry-source-file="navigation-popover.tsx">
      <Popover.Trigger ref={triggerRef} aria-label="Site Navigation" className="reset-button NavigationPopoverTrigger" data-sentry-element="Popover.Trigger" data-sentry-source-file="navigation-popover.tsx">
        {children}
      </Popover.Trigger>

      <Popover.Portal data-sentry-element="Popover.Portal" data-sentry-source-file="navigation-popover.tsx">
        <Theme asChild data-sentry-element="Theme" data-sentry-source-file="navigation-popover.tsx">
          <Popover.Content forceMount align="start" alignOffset={-110} className="NavigationPopoverContent" sideOffset={8} onKeyDown={event => {
          // Focus a link on initial arrow key press, NavigationMenu handles the rest
          if (event.target === event.currentTarget) {
            if (event.key === 'ArrowDown' || event.key === 'ArrowLeft') {
              event.currentTarget.querySelector('a')?.focus();
            }
            if (event.key === 'ArrowUp' || event.key === 'ArrowRight') {
              [...event.currentTarget.querySelectorAll('a')].at(-1)?.focus();
            }
          }
        }} data-sentry-element="Popover.Content" data-sentry-source-file="navigation-popover.tsx">
            <div style={{
            width: 798
          }}>
              <NavigationItems data-sentry-element="NavigationItems" data-sentry-source-file="navigation-popover.tsx" />
            </div>
          </Popover.Content>
        </Theme>
      </Popover.Portal>
    </Popover.Root>;
};